export default __webpack_public_path__ + "static/media/Voting-Results-and-Scrutinizers-Report-of-21st-AGM.8ef87497.pdf";